import { config_baseURL } from '@/config'

// baseURL 初始化
export const baseURL = config_baseURL

const imageProxyPrefix = baseURL + '/imageProxy?url='

export const proxyImage = (url) => {
  return imageProxyPrefix + encodeURIComponent(url)
}

export const avatarImageSrc = (url) => {
  const value = String(url || '').trim()
  if (!value) {
    return ''
  }
  if (/^https?:\/\/photo\.chaoxing\.com\/p\//i.test(value)) {
    return value.replace(/^http:\/\//i, 'https://').split('?')[0]
  }
  return proxyImage(value)
}
